<template>
<div class="timerbar-warp">
  <div class="timerbar">
    <div class="timerbar-item">
      <img src="~_img/timer-icon.png" alt="">
      <span class="title">中考倒计时</span>
      <div class="time-warp">
        <div class="time day">
          <span v-for="(item1,key1) in middleTimeShow.day" :key="key1">{{item1}}</span>
        </div><span class="text">天</span>
        <div class="time hours">
          <span v-for="(item2,key2) in middleTimeShow.hours" :key="key2">{{item2}}</span>
        </div><span class="text">时</span>
        <div class="time minutes">
          <span v-for="(item3,key3) in middleTimeShow.minutes" :key="key3">{{item3}}</span>
        </div><span class="text">分</span>
        <div class="time seconds">
          <span v-for="(item4,key4) in middleTimeShow.seconds" :key="key4">{{item4}}</span>
        </div><span class="text text-seconds">秒</span>
      </div>
    </div>
    <div class="line"></div>
    <div class="timerbar-item">
      <img src="~_img/timer-icon.png" alt="">
      <span class="title">高考倒计时</span>
      <div class="time-warp">
        <div class="time day">
          <span v-for="(item1,key1) in highTimeShow.day" :key="key1">{{item1}}</span>
        </div><span class="text">天</span>
        <div class="time hours">
          <span v-for="(item2,key2) in highTimeShow.hours" :key="key2">{{item2}}</span>
        </div><span class="text">时</span>
        <div class="time minutes">
          <span v-for="(item3,key3) in highTimeShow.minutes" :key="key3">{{item3}}</span>
        </div><span class="text">分</span>
        <div class="time seconds">
          <span v-for="(item4,key4) in highTimeShow.seconds" :key="key4">{{item4}}</span>
        </div><span class="text text-seconds">秒</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "timerbar",
  data() {
    return {
      highTime: "2021/06/07",
      middleTime: "2021/06/24",
      highTimeShow: {
        day: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliSeconds: 0,
      },
      middleTimeShow: {
        day: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliSeconds: 0,
      },
    };
  },
  mounted() {
    this.restTime();
    setInterval(() => {
      this.restTime();
    }, 1000);
  },
  methods: {
    formatTime(restTime) {
      // 计算毫秒
      let milliSeconds = restTime % 1000;
      milliSeconds = Math.floor(milliSeconds / 100);
      restTime = restTime / 1000;
      // 计算出相差天数
      let day = Math.floor(restTime / (24 * 3600));
      if (day >= 10 && day <= 100) {
        day = "0" + (day || 0);
      } else if (day <= 10) {
        day = "00" + (day || 0);
      } else {
        day = day + "";
      }
      // 计算出小时
      let leave1 = restTime % (24 * 3600);
      let hours = Math.floor(leave1 / 3600);
      hours = hours >= 10 ? hours+"" : "0" + (hours || 0);
      // 计算相差分钟数
      let leave2 = leave1 % 3600;
      let minutes = Math.floor(leave2 / 60);
      minutes = minutes >= 10 ? minutes+"" : "0" + (minutes || 0);
      // 计算相差秒数
      let leave3 = leave2 % 60;
      let seconds = Math.floor(leave3);
      seconds = seconds >= 10 ? seconds+"" : "0" + (seconds || 0);
      return {
        day,
        hours,
        minutes,
        seconds,
        milliSeconds,
      };
    },
    restTime() {
      let nowTime = new Date();
      let setHighTime = new Date(this.highTime);
      let setMiddleTime = new Date(this.middleTime);
      let restHighTime = setHighTime.getTime() - nowTime.getTime();
      let restMiddleTime = setMiddleTime.getTime() - nowTime.getTime();
      this.highTimeShow = this.formatTime(restHighTime);
      this.middleTimeShow = this.formatTime(restMiddleTime);
      // console.log(this.highTimeShow,this.middleTimeShow,"highTimeShow");
    },
  },
};
</script>
<style scoped lang="scss">
.timerbar-warp {
  width: 100%;
  background: #e6c89d;
  .timerbar {
    width: 1200px;
    height: 63px;
    margin: 0 auto;
    .timerbar-item {
      float: left;
    }
    img {
      width: 26px;
      height: 26px;
      margin-top: 19px;
      margin-right: 9px;
      float: left;
    }
    .title {
      display: table-cell;
      font-size: 22px;
      font-family: FZLanTingHeiS-DB-GB;
      font-weight: 400;
      color: #000000;
      line-height: 63px;
      float: left;
    }
    .time-warp {
      display: inline-block;
      margin-left: 18px;
      height: 40px;
      margin-top: 12px;
      .time {
        width: 57px;
        height: 40px;
        display: inline-block;
        background: url("~_img/coursecardimg/timerbg2.png");
        span {
          display: inline-block;
          width: 28px;
          height: 40px;
          font-size: 20px;
          font-family: FZLanTingHeiS-EB-GB;
          font-weight: 400;
          color: #4c2f06;
          line-height: 40px;
          text-align: center;
        }
      }
      .day {
        width: 84px;
        height: 40px;
        display: inline-block;
        background: url("~_img/coursecardimg/timerbg1.png");
      }
      .text {
        display: inline-block;
        width: 42px;
        height: 40px;
        font-size: 22px;
        font-family: FZLanTingHei-R-GBK;
        font-weight: 400;
        color: #000000;
        line-height: 40px;
        text-align: center;
      }
      .text-seconds {
        width: 32px;
        text-align: right;
      }
    }
    .line {
      width: 21px;
      border-left: 1px solid #7D6240;
      height: 31px;
      margin: 18px 0 15px 24px;
      line-height: 31px;
      float: left;
    }
  }
}
</style>
